import React from 'react';
import { AssetBase } from './AssetBase';
import { AssetItem } from '@/type';
import { Space, Tooltip } from '@easyv/react-components';
import { ProButton } from '@/UIGenerator/uicomponents/ProButton';
import { ModelOutlined } from '@easyv/react-icons';

interface ModelProps {
  canDrag?: boolean;
  canRename?: boolean;
  data: AssetItem<'model'>;
  hideDetail?: boolean;
  onSelected: (item: AssetItem) => void;
}

export function Model({
  canDrag = false,
  canRename = false,
  hideDetail = false,
  data,
  onSelected,
}: ModelProps) {
  return (
    <AssetBase
      canDrag={canDrag}
      canRename={canRename}
      data={data}
      hideDetail={hideDetail}
      defaultThumb={'@/assets/img/model.png'}
      hoverRender={
        <Space direction='vertical' align='center'>
          <Tooltip content='更新后模型相关的蓝图节点需更新配置'>
            <ProButton
              size='small'
              type='primary'
              className='w-14 h-6 leading-4 p-0'
              onClick={(e) => {
                e.preventDefault();
                onSelected?.(data);
              }}
            >
              更新
            </ProButton>
          </Tooltip>
        </Space>
      }
      icon={<ModelOutlined size={16} />}
    />
  );
}
